import Skeleton from "../../../components/Skeleton/Skeleton";
import TableSkeleton from "../../../components/Skeleton/ui/TableSkeleton/TableSkeleton";
import useScreenSize from "../../../hooks/useScreenSize";

const PageSkeleton = () => {
  const { isMobile } = useScreenSize();

  return (
    <div className="flex flex-col gap-6">
      {!isMobile && (
        <div className="flex items-center justify-between">
          <div className="flex flex-col gap-1">
            <Skeleton width="160px" height="32px" />
            <Skeleton width="220px" height="20px" />
          </div>
          <div className="flex gap-3">
            <Skeleton width="136px" height="40px" />
            <Skeleton width="100px" height="40px" />
            <Skeleton width="110px" height="40px" />
          </div>
        </div>
      )}

      {/* Balance card */}
      <div className="rounded-xl border border-[#EBEBEB] p-6">
        <Skeleton width="120px" height="16px" className="mb-3" />
        <Skeleton width="200px" height="36px" />
      </div>

      {/* Table section */}
      <div className="flex flex-col gap-4">
        <div className="flex items-center justify-between">
          <Skeleton width="140px" height="24px" />
          {isMobile && <Skeleton width="80px" height="24px" />}
        </div>
        <TableSkeleton numberOfColumns={4} numberOfRows={5} />
      </div>
    </div>
  );
};

export default PageSkeleton;
